import { render } from "./SquadItem.vue?vue&type=template&id=6ac087cf&scoped=true"
import script from "./SquadItem.vue?vue&type=script&lang=js"
export * from "./SquadItem.vue?vue&type=script&lang=js"

import "./SquadItem.vue?vue&type=style&index=0&id=6ac087cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac087cf"]])

export default __exports__